import { render, staticRenderFns } from "./displayServicesCustomers.vue?vue&type=template&id=279af8b2&scoped=true&"
import script from "./displayServicesCustomers.vue?vue&type=script&lang=js&"
export * from "./displayServicesCustomers.vue?vue&type=script&lang=js&"
import style0 from "./displayServicesCustomers.vue?vue&type=style&index=0&id=279af8b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279af8b2",
  null
  
)

export default component.exports